export default __webpack_public_path__ + "static/banner-moc-1-1-b9db868a61ea0184f8768352b173db72.png";